import { render, staticRenderFns } from "./OmtkMoveProductInfoDialog.vue?vue&type=template&id=6153fef4"
import script from "./OmtkMoveProductInfoDialog.vue?vue&type=script&lang=js"
export * from "./OmtkMoveProductInfoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports